import { isSameDay } from "date-fns";
import dayjs from "dayjs";
import { IconChevronDown } from "@tabler/icons-react";
import { Stack, Typography } from "@altimateai/lego";
import { cn } from "@/lib/utils";

export interface TriggerProps {
  id: string;
  startDate?: Date;
  endDate?: Date;
  isOpen: boolean;
  wrapperClass?: string;
  showTimezone?: boolean;
  label?: string;
  staticRangeLabel: string | false;
  renderDateRange: () => React.ReactNode;
}

const formatDateShort = (date: Date) => {
  return dayjs(date).format("DD/MM/YY");
};

const InlineTrigger = ({ id, startDate, endDate, isOpen, wrapperClass }: TriggerProps) => {
  const dateText =
    startDate && endDate
      ? isSameDay(startDate, endDate)
        ? `Is ${formatDateShort(startDate)}`
        : `Is ${formatDateShort(startDate)} - ${formatDateShort(endDate)}`
      : "Select date range";

  return (
    <Stack
      id={id}
      className={cn(
        "al-inline-flex al-items-center al-gap-2 al-rounded al-border al-border-gray-200 al-px-3 al-py-2 al-cursor-pointer hover:al-border-gray-300",
        wrapperClass
      )}
      aria-label="Date range picker"
      aria-expanded={isOpen}
    >
      <Typography variant="body" size="xs" className="al-text-gray-500">
        Date Range:
      </Typography>
      <Typography
        variant="body"
        size="xs"
        className="al-text-primary al-font-medium"
        aria-label="Selected date range"
      >
        {dateText}
      </Typography>
      <IconChevronDown size={18} className="al-text-primary" />
    </Stack>
  );
};

export default InlineTrigger;
